<template>
    <!-- Hero Start -->
    <section>
        <div class="about-header">
            <div class="container">
                <div class="row mb-5 d-flex flex-wrap">
                    <div class="col-lg-6 col-6 wow slideInLeft" align="center">
                        <div class="card border-0 bg-transparent text-center about-img">
                            <img src="assets/img/logo-australian-made.png">
                        </div>
                    </div>
                    <div class="col-lg-6 col-6 wow slideInLeft" align="center">
                        <div class="card border-0 bg-transparent text-center about-img">
                            <img src="assets/img/logo-tga.png">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- Hero End -->
</template>

<script>
import axios from 'axios'

export default {
    name: 'SectionAbout',

    data() {
        return {
            show: 0,
            username: null,
            noTelp: '62811959901',
            datasectionSlider: {
                title1: null,
                title2: null,
                title3: null,
                title4: null,
                title5: null,
                desc: null,
                button1: null,
                button2: null,
            },
            styleIphone: {
                marginTop: null
            },
            flagImage: 'flag-id.png',
            paddingTop: null
        }
    },
    mounted() {
        // this.username = window.location.pathname.replace("/", "");
        this.username = this.$route.params.username
        // console.log(this.username)
        if (this.username) {
            axios
                .get(`https://api.bisnisonlinebgs.com/api/content/member/getMemberById/${this.username}`)
                .then(response => {
                    this.noTelp = response.data.data[0].mobile_no
                    // console.log(response.data.data[0].mobile_no)
                });
        }

        if (localStorage.getItem('lang_nad') == null) {
            localStorage.setItem('lang_nad', 'id')
            this.flagImage = 'flag-en.png'
        } else if (localStorage.getItem('lang_nad') == 'id') {
            this.flagImage = 'flag-en.png'
        } else if (localStorage.getItem('lang_nad') == 'en') {
            this.flagImage = 'flag-id.png'
        }

        // if(this.username == ""){
        //     document.getElementById("showLocation").style.display = "block";
        // }else if(this.username !== ""){
        //     document.getElementById("showLocation").style.display = "none";
        // }

        axios.get(`../../lang.json`).then(response => {
            let datasectionSlider
            if (localStorage.getItem('lang_nad') == 'id') {
                datasectionSlider = response.data.id[0];
            } else if (localStorage.getItem('lang_nad') == 'en') {
                datasectionSlider = response.data.en[0];
            }

            this.datasectionSlider.title1 = datasectionSlider.sectionSlider.title1
            this.datasectionSlider.title2 = datasectionSlider.sectionSlider.title2
            this.datasectionSlider.title3 = datasectionSlider.sectionSlider.title3
            this.datasectionSlider.title4 = datasectionSlider.sectionSlider.title4
            this.datasectionSlider.title5 = datasectionSlider.sectionSlider.title5
            this.datasectionSlider.desc = datasectionSlider.sectionSlider.desc
            this.datasectionSlider.button1 = datasectionSlider.sectionSlider.button1
            this.datasectionSlider.button2 = datasectionSlider.sectionSlider.button2
        })

        if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
            this.styleIphone.marginTop = '8px'
            this.paddingTop = '12px'
        }
    },
}
</script>
